import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Billetterie from './Billetterie';
import PrivacyPolicy from './privacypolicy'; // Importé sous le nom PrivacyPolicy (avec P majuscule)import Billetterie from './Billetterie';
import Contact from './Contact';
import APropos from './APropos';
import Header from './components/Header';
import Footer from './components/Footer';
import Articles from './Articles';
import Gallery from './components/Gallery';
import Complique from './album/Complique';
import Coulisse2024 from './album/Coulisse2024';
import Diva from './album/Diva';
import Gorille from './album/Gorille';
import Logequipeut from './album/Logequipeut';
import Retraite from './album/Retraite';
import Salonasso from './album/Salonasso';
import Uneheure from './album/Uneheure';
import styled, { createGlobalStyle } from 'styled-components';
import BlogPost from './components/BlogPost';
import Portfolio from './Portfolio';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Blog from './Blog';
import './styles/header.css';
import Panier from './Panier';
import Malle from './album/Malle';
import Bistrotdesmagouilles from './album/Bistrotdesmagouilles';
import { AuthProvider } from './context/AuthContext';
import Inscription from './membres/Inscription';
import Connexion from './membres/Connexion';
import EspaceMembres from './membres/EspaceMembres';
import Admin from './membres/Admin';
import ProtectedRoute from './membres/ProtectedRoute';
import Profil from './membres/Profil';
import ResetPassword from './membres/ResetPassword';

// Global Style
const GlobalStyle = createGlobalStyle`
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-color: ${(props) => (props.theme === 'dark' ? '#121212' : '#ffffff')};
    color: ${(props) => (props.theme === 'dark' ? '#ffffff' : '#000000')};
    transition: background-color 0.3s, color 0.3s;
  }
`;

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const savedTheme = localStorage.getItem('theme') || 'dark';
  const [theme, setTheme] = useState(savedTheme);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <Router>
      <AuthProvider>
      <ScrollToTop />
      <GlobalStyle theme={theme} />
      <AppWrapper>
        <Header theme={theme} toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<Home />} />
<Route path="/privacypolicy" element={<PrivacyPolicy />} />          <Route path="/gallery" element={<Gallery />} />
          <Route path="/billetterie" element={<Billetterie />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apropos" element={<APropos />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/album/complique" element={<Complique />} />
          <Route path="/album/coulisse2024" element={<Coulisse2024 />} />
          <Route path="/album/diva" element={<Diva />} />
          <Route path="/album/gorille" element={<Gorille />} />
          <Route path="/album/logequipeut" element={<Logequipeut />} />
          <Route path="/album/retraite" element={<Retraite />} />
          <Route path="/album/Salonasso" element={<Salonasso />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/album/Uneheure" element={<Uneheure />} />
          <Route path="/panier" element={<Panier />} />
          <Route path="/album/Malle" element={<Malle />} />
          <Route path="/album/Bistrotdesmagouilles" element={<Bistrotdesmagouilles />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/reinitialisation-mot-de-passe" element={<ResetPassword />} />
         <Route  path="/profil"  element={    <ProtectedRoute> <Profil /> </ProtectedRoute>  }/>
          <Route
            path="/espace-membres"
            element={
              <ProtectedRoute>
                <EspaceMembres />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-membres"
            element={
              <ProtectedRoute adminOnly>
                <Admin />
              </ProtectedRoute>
            }
          />

        </Routes>
        <Footer isDarkMode={theme === 'dark'} />
      </AppWrapper>
      </AuthProvider>
    </Router>
  );
}

export default App;
